import { Modal } from "antd";
import { getIsHelmReleaseItem } from "../services/utils";
import { NGButton } from "../newcomponents/button/Button";

export function trySaveWithReleaseWarning(
  item: { tags?: { [key: string]: any } },
  onConfirm: () => void | Promise<void>,
  onCancel?: () => void,
): void {
  if (!getIsHelmReleaseItem(item)) {
    onConfirm();
    return;
  }

  const modal = Modal.confirm({
    title: "Template/Helm Override Warning",
    content: (
      <div>
        <div>
          You're editing an item managed by Template/Helm. Any manual changes will be{" "}
          <span className="font-semibold">overwritten</span> when the Template Release or Helm Release is updated.
        </div>
        <div className="mt-2">Do you want to continue?</div>
      </div>
    ),
    footer: (
      <div className="modal-actions">
        <NGButton
          variant="danger"
          outlined
          onClick={() => {
            if (onCancel) {
              onCancel();
            }
            modal.destroy();
          }}
        >
          Cancel
        </NGButton>
        <NGButton
          variant="primary"
          onClick={() => {
            onConfirm();
            modal.destroy();
          }}
        >
          OK
        </NGButton>
      </div>
    ),
    onCancel: () => {},
    onOk: () => {},
  });
}
